export enum PaymentResolveRadioValues {
  RESUME_PAYMENT = 'resume-payment',
  DONT_RESUME_PAYMENT = 'dont-resume-payment'
}

export const FORMATTED_PAYMENT_RESOLVE_VALUES = {
  [PaymentResolveRadioValues.RESUME_PAYMENT]: 'Resume recurring charges',
  [PaymentResolveRadioValues.DONT_RESUME_PAYMENT]: 'Keep charges paused'
}
